import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_probationary_time_periods_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_probationary_time_periods_line_legal_requirements',
  name: 'Are probationary (time) periods in line with legal requirements?',
  description:
    'This question refers to probationary/ trial time periods. It does not include apprentices, trainees or interns.',
  meta: {
    slcpMeta: {
      key: 'ep-5--1',
      number: 'RH-EMP-26',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-5--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27030,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
